import { isEmpty, lowerCase, upperCase } from "lodash";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const CasinoWeb = ({ data, handel, platForm, tab }) => {
  const navigate = useNavigate();
  const { key, type } = useParams();
  let object = {
    casino: "/assets/new/ld_new.webp",
    slot: "/assets/new/rng_new.webp",
    crash: "/assets/new/crash_new.webp",
    table: "/assets/new/table_new.webp",
    cricket: "/assets/new/cricket_new.webp",
    fishing: "/assets/new/fishing_new.webp",
  };
  return (
    <div className="mx-auto gamesCardContainer v-card v-sheet theme--light">
      <div
        className="v-image v-responsive align-end hidden-sm-and-down theme--light"
        style={{
          "border-top-right-radius": "0px",
          "border-top-left-radius": "0px",
        }}
      >
        <div
          className="v-responsive__sizer"
          style={{ "padding-bottom": "21.4286%" }}
        />
        <div
          className="v-image__image v-image__image--cover"
          style={{
            "background-image": `url(${object[type]})`,
            "background-position": "center center",
          }}
        />
        <div className="v-responsive__content">
          <div className="v-card__title white--text font-weight-bold">
            <div className="game_banner_text" />
          </div>
        </div>
      </div>
      <div className="margin-desktop">
        <div className="row game-vendor-list-container hidden-sm-and-down no-gutters">
          <div className="text-left d-flex flex-wrap justify-start col col-12">
            <div
              onClick={() => navigate(`/casino/${tab}`)}
              className="vendor-list-item elevation-0 slot-product"
            >
              <button
                type="button"
                className={`text-capitalize text-center font-weight-bold my-0 vendor-list-item-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default ${
                  isEmpty(key) ? "selectedProvider" : ""
                }`}
                style={{ height: "auto", "min-height": "40px" }}
              >
                <span className="v-btn__content">
                  <div className="row">
                    <div className="pa-0 col col-12">All</div>
                  </div>
                </span>
              </button>
            </div>
            {type != "cricket" &&
              platForm?.map((res) => {
                return (
                  <div
                    onClick={() =>
                      navigate(`/casino/${tab}/${lowerCase(res?.key)}`)
                    }
                    className="vendor-list-item elevation-0 slot-product"
                  >
                    <button
                      type="button"
                      className={`text-capitalize text-center font-weight-bold my-0 vendor-list-item-button v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default ${
                        upperCase(key) == res?.key ? "selectedProvider" : ""
                      }`}
                      style={{ height: "auto", "min-height": "40px" }}
                    >
                      <span className="v-btn__content">
                        <div className="row">
                          <div
                            aria-disabled={0}
                            className="pa-0 d-flex align-center justify-center col col-12"
                            style={{ gap: "3%" }}
                          >
                            <div className="v-image v-responsive provider_btn theme--light">
                              <div
                                className="v-responsive__sizer"
                                style={{ "padding-bottom": "100%" }}
                              />
                              <div
                                className="v-image__image v-image__image--cover"
                                style={{
                                  "background-image": `url(${res?.imgWeb})`,
                                  "background-position": "center center",
                                }}
                              />
                              <div
                                className="v-responsive__content"
                                style={{ width: "150px" }}
                              />
                            </div>
                            <span
                              style={{
                                "font-family": "Heebo-Regular, sans-serif",
                              }}
                            >
                              {res?.key}
                            </span>
                          </div>
                        </div>
                      </span>
                    </button>
                  </div>
                );
              })}
          </div>
        </div>

        <div
          role="list"
          className="v-list slot-game-card-select px-2 v-sheet theme--light"
        >
          {data?.map((res) => {
            return (
              <div
                onClick={() => handel(res)}
                tabIndex={-1}
                role="listitem"
                className="v-list-item theme--light px-0 slot-game-card-item text-center mb-5"
              >
                <div className="elevation-0 v-card v-sheet theme--light">
                  <span right className="v-badge v-badge--overlap theme--light">
                    <div
                      className="v-avatar game_icon_sizing gameButton"
                      style={{
                        height: "48px",
                        "min-width": "48px",
                        width: "48px",
                      }}
                    >
                      <div className="v-image v-responsive theme--light">
                        <div
                          className="v-responsive__sizer"
                          style={{ "padding-bottom": "100%" }}
                        />
                        <div
                          className="v-image__image v-image__image--cover"
                          style={{
                            "background-image": `url(${res?.img})`,
                            "background-position": "center center",
                          }}
                        />
                        <div
                          className="v-responsive__content"
                          style={{ width: "450px" }}
                        />
                      </div>
                      <div className="slot-game-button-container">
                        <div className="slot-game-button-container-box">
                          <div className="slot-game-button-box d-flex justify-center">
                            <button
                              type="button"
                              className="slot-game-button v-btn v-btn--icon v-btn--round theme--light v-size--default"
                            >
                              <span className="v-btn__content">
                                <div
                                  className="v-avatar"
                                  style={{
                                    height: "60px",
                                    "min-width": "60px",
                                    width: "60px",
                                  }}
                                >
                                  <img src="/assets/images/play_btn.svg" alt />
                                </div>
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </span>
                </div>
                <span className="v-tooltip v-tooltip--bottom" />
                <div
                  aria-haspopup="true"
                  aria-expanded="false"
                  className="v-card__text pt-2 font-weight-bold slot-game-name-box text-center elevation-0"
                >
                  {res?.name || res?.key}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CasinoWeb;
